import React, { useState } from "react";
import { useForm, Controller } from "react-hook-form";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import CloseIcon from "@material-ui/icons/Close";
import {
  Button,
  Typography,
  DialogActions,
  TextField,
  Grid,
  makeStyles,
} from "@material-ui/core";
import { sendEmail } from "../action";
import { useDispatch } from "react-redux";
const useStyles = makeStyles((theme) => ({
  dialogTitle: {
    backgroundColor: "white",
    color: "#4f2d7f",
    display: "flex",
    // justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(2),
  },
  formContainer: {
    // padding: theme.spacing(3),
  },
  submitButton: {
    width: "30%",
    marginTop: "1em",
    backgroundColor: "#4f2d7f",
    color: "#fff",
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: "#4F2D7F",
    },
  },
  errorMessage: {
    color: "red",
    fontSize: "0.85rem",
    marginTop: "4px",
  },
}));

const EmailModal = ({
  openEmailModal,
  setOpenEmailModal,
  handleEmailSubmit,
}) => {
  const [value, setValue] = useState("");
  const [error, setError] = useState(false);
  const [helperText, setHelperText] = useState("");

  // Function to validate email
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // Handle email change
  const handleChange = (e) => {
    const email = e.target.value;
    setValue(email);

    if (!validateEmail(email)) {
      setError(true);
      setHelperText("Invalid email format");
    } else {
      setError(false);
      setHelperText("");
    }
  };

  return (
    <Dialog
      aria-labelledby="customized-dialog-title"
      fullWidth={true}
      maxWidth="xs"
      open={openEmailModal}
      onClose={() => setOpenEmailModal(false)}
    >
      <MuiDialogTitle
        disableTypography
        style={{ color: "#4f2d7f", backgroundColor: "white" }}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div></div>
          <Typography variant="h6">
            {"Enter Recipient Email Address"}
          </Typography>
          <CloseIcon
            onClick={() => setOpenEmailModal(false)}
            style={{ cursor: "pointer" }}
          />
        </div>
      </MuiDialogTitle>
      <MuiDialogContent dividers>
        {/* <Grid container spacing={2} style={{ marginTop: "10px" }}>
          <Grid item xs={12}>
            <Controller
              name="email"
              control={control}
              rules={{
                required: "Required",
                pattern: {
                  value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                  message: "Enter a valid email address",
                },
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Enter Email *"
                  fullWidth
                  error={!!errors.email}
                  helperText={errors.email?.message}
                  
                />
              )}
            />
          </Grid>
        </Grid>
        <DialogActions style={{ display: "flex", justifyContent: "center" }}>
          <Button
            onClick={handleSubmit(handleEmailSubmit)}            
            variant="contained"
            className={classes.submitButton}
          >
            Submit
          </Button>
        </DialogActions> */}

        <Grid container spacing={2} style={{ marginTop: "10px" }}>
          <Grid item xs={12}>
            <TextField
              label="Enter Email"
              required
              fullWidth
              // onChange={(e) => setValue(e.target.value)}
              onChange={handleChange}
              error={error}
              helperText={helperText}
            />
          </Grid>
        </Grid>

        <DialogActions style={{ display: "flex", justifyContent: "center" }}>
          <Button
            style={{
              width: "30%",
              marginTop: "1em",
              backgroundColor: "#4f2d7f",
              color: "#fff",
              textTransform: "capitalize",
            }}
            disabled={error}
            onClick={() => handleEmailSubmit(value)}
          >
            Submit
          </Button>{" "}
        </DialogActions>
      </MuiDialogContent>
    </Dialog>
  );
};

export default EmailModal;
